import React from 'react';
import { withRouter } from 'react-router';
import { Button, Alert, Icon } from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';

import s from './style.less';
import ProviderBlock from '../../components/NavBar';
import Breadcreumb from '../../components/Breadcrumb';

class Claim extends React.Component {
  static propTypes = {
    match: PropTypes.object,
    history: PropTypes.object,
  };

  state = {
    plan: false,
    Provider: false,
    Customer: { User: false },
    booking: false,
    component: false,
    bookingId: this.props.match.params.id,
    CarMaker: {},
    CarModel: {},
  };

  componentDidMount() {
    this.getSpDetails();
  }

  getSpDetails = async () => {
    try {
      const req = await fetch(
        `/provider/claim/details/${this.state.bookingId}`,
      );
      return this.setState({
        plan: req.plan,
        component: req.plan.Bookings[0].Component,
        booking: req.plan.Bookings[0],
        Provider: req.plan.Provider,
        Customer: req.plan.Customer,
        CarMaker: req.car.maker,
        CarModel: req.car.model,
      });
    } catch (e) {
      this.setState({ error: (e.error || e).toString() });
    }
  };

  breadcrumbs = [
    { name: 'Home', to: '/' },
    {
      name: 'Manage bookings',
      to: '/provider/bookings',
      react: true,
    },
    { name: 'Make a Claim' },
  ];

  submitClaim = async () => {
    await fetch(`/provider/claim/submit/${this.state.bookingId}`, {
      method: 'post',
    });
    await this.getSpDetails();
  };

  renderComponents = () => {
    const { component } = this.state;
    const items = [];
    items.push({
      name: component.type,
      price: component.totalServiceCost,
    });
    return items.map((i, key) => (
      <div key={key}>
        <div>{i.name}</div>
        <div>&pound;{(i.price || 0).toFixed(2)}</div>
      </div>
    ));
  };

  render() {
    const {
      booking: { carNumber },
      plan: { VRN, VRN2 },
    } = this.state;
    const registration = carNumber === 1 ? VRN : VRN2;

    return (
      <ProviderBlock withPadding>
        <Breadcreumb paths={this.breadcrumbs} />
        {this.state.error && <Alert type="error" message={this.state.error} />}
        <div>
          <Button
            onClick={() => this.props.history.goBack()}
            className={`${s.btn} ${s.left}  ${s.hide_print}`}
          >
            <Icon type="arrow-left" />Back
          </Button>
          <div className={s.body}>
            <div className={s.header}>Make a Claim</div>
            <div className={s.big}>
              Booking date:{' '}
              {moment(this.state.booking.bookDate).format('DD.MM.YYYY')}
            </div>
            <div className={s.big}>
              Contract number: {this.state.plan.contractNumber}
            </div>
            {registration && (
              <div className={s.big}>Car Registration: {registration}</div>
            )}
            <div className={s.big}>Car Make: {this.state.CarMaker.name}</div>
            {this.state.CarMaker && (
              <div className={s.big}>Car Model: {this.state.CarModel.name}</div>
            )}
            <div className={s.big}>{this.state.component.type}</div>
            <br />
            <div className={s.border}>
              <div className={s.flex1}>
                <div className={s.flex1}>
                  <div>
                    <div className={s.medium}>Customer Details</div>
                    <div>
                      {this.state.Customer.firstName}
                      &nbsp;
                      {this.state.Customer.lastName}
                    </div>
                    <div>{this.state.Customer.User.email}</div>
                    <div>
                      {this.state.Customer.mobilePhone ||
                        this.state.Customer.phone}
                    </div>
                  </div>
                </div>
                <div className={s.flex1}>
                  <div>
                    <div className={s.medium}>Servicing Centre</div>
                    <div>{this.state.Provider.companyName}</div>
                    <div>{this.state.Provider.phone}</div>
                    <div>{this.state.Provider.addressLine1}</div>
                  </div>
                </div>
              </div>
              <hr />
              <div className={`${s.medium} ${s.service_details}`}>
                Service details
              </div>
              <br />
              <div className={s.components}>
                {this.renderComponents()}
                <div className={s.total_top}>
                  <div>Subtotal</div>
                  <div>
                    &pound;{(this.state.component.claimFund || 0).toFixed(2)}
                  </div>
                </div>
                <div>
                  <div>VAT 20%</div>
                  <div>
                    &pound;{(
                      (this.state.component.claimFund || 0) * 0.2
                    ).toFixed(2)}
                  </div>
                </div>
                <div className={s.total_bottom}>
                  <div>Total</div>
                  <div>
                    &pound;{(
                      (this.state.component.claimFund || 0) * 1.2
                    ).toFixed(2)}
                  </div>
                </div>
              </div>
              <div className={s.border_line} />
            </div>

            <div className={s.buttons}>
              {this.state.booking.BookingStatusId === 3 && (
                <button onClick={this.submitClaim} className={s.btn}>
                  Submit Claim
                </button>
              )}
              {this.state.booking.BookingStatusId > 3 && (
                <button className={s.btn}>
                  <a
                    href={`/reports/claim/${this.state.bookingId}`}
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    Claim Invoice
                  </a>
                </button>
              )}
              <button onClick={window.print} className={s.btn}>
                Print
              </button>
            </div>
            {this.state.booking.BookingStatusId > 3 && (
              <div className={s.alignRight}>
                {this.state.booking.BookingStatus.garageMessage}
                {this.state.booking.BookingStatusId === 4 && (
                  <span>&nbsp;- Awaiting Authorisation</span>
                )}
              </div>
            )}
          </div>
        </div>
      </ProviderBlock>
    );
  }
}

export default withRouter(Claim);
